export default "__VITE_ASSET__B0V7xq36__"